<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    @if (!modalData.amazonUserAccess || modalData.amazonUserAccess.length === 0) {
      {{ t("renew-amazon-access-modal.no_advertising_access") }}
    } @else {
      @for (access of modalData.amazonUserAccess; track access) {
        <li class="flex list-none items-center gap-2">
          @if (!access.isValidToken) {
            <IIcon name="alertTriangle" class="text-red-500" />
            {{ t("renew-amazon-access-modal.token_no_longer_valid", [access.email]) }}
          } @else if (!access.hasAccessToProfile) {
            <IIcon name="alertTriangle" class="text-orange-500" />
            {{ t("renew-amazon-access-modal.no_advertising_campaign_manager", [access.email]) }}
          } @else {
            <IIcon name="checkCircle" class="text-green-500" />
            {{ access.email }}
          }
        </li>
      }
    }
  </div>
  <div class="mt-2 flex justify-end gap-2">
    <button iButton variant="ghost" size="md" (click)="close()">{{ t("common.close") }}</button>
    @if (modalData.canRenewAccess) {
      <button iButton variant="secondary" size="md" (click)="renew()">
        {{ t("renew-amazon-access-modal.renew_or_add_access") }}
      </button>
    }
  </div>

  <ISpinner [display]="loading()" main withTitle />
</ng-container>
